export const possessivePronouns_Cards = [["דִּידִי ", "mine"], ["דִּידָךְ ", "yours (sing.)"], ["דִּידֵיה", "his"], ["דִּידָה ", "hers"], ["דִּידָן ", "ours"], ["דִּידְכוּ ", "yours (pl.)"], ["דִּידְהוּ ", "theirs"]];
